import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Cookies } from '../../../../index.js';
import { ClipLoader, PulseLoader } from 'react-spinners';

const Description = () => {
    const { slug_1, slug_2, slug_3, slug_4 } = useParams();

    const [users, set_users] = useState('');

    const laythongtin = (data) => {
        axios
            .post('https://hust.media/api/profile/profile.php', data)
            .then(response => set_users(response.data))
            .catch(error => console.log(123 + error));
    };

    useEffect(() => {
        if (slug_3 == 'shop') {
            // nếu là play thì gửi accounts_seller_id
            laythongtin({
                accounts_seller_id: slug_4,
                chedo: 'accounts_profile',
            });
        } else {
            // còn lại thì gửi apikey
            const apiKey = Cookies.get('apikey');
            laythongtin({
                apikey: apiKey,
                chedo: 'accounts_profile',
            });
        }
    }, []); // chỉ chạy 1 lần khi load

    return (
        <>
            {!users &&
                (<>
                    <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                        <ClipLoader color="#fff" size={150} />
                    </div>
                </>)}
            {users &&
                (
                    <>
                        <div className='px-1 py-3 bg-slate-100 mt-2'>
                            <h5>Mô tả shop</h5>
                            <div className='flex items-center gap-2 text-base lg:text-lg'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    strokeWidth={1.5}
                                    stroke='currentColor'
                                    className='w-4 h-4'>
                                    <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        d='M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z'
                                    />
                                </svg>

                                <span className='min-w-[110px] lg:min-w-[200px]'>Tiêu đề shop</span>
                                <span>{users.shop_caption}</span>
                            </div>
                            {users.username && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 20.118a7.5 7.5 0 0115 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.5-1.632z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Username</span>
                                    <span>{users.username}</span>
                                </div>
                            )}
                            <div className='flex items-center gap-2 text-base lg:text-lg'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    strokeWidth={1.5}
                                    stroke='currentColor'
                                    className='w-4 h-4'>
                                    <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        d='M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z'
                                    />
                                </svg>

                                <span className='min-w-[110px] lg:min-w-[200px]'>Mô tả shop</span>
                                <span>{users.shop_description}</span>
                            </div>
                            {users.total_nap && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M12 6v12m6-6H6'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Tổng kiếm dc</span>
                                    <span>{users.total_nap}</span>
                                </div>
                            )}
                            {users.namelevel && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M12 3.75l2.318 4.695 5.182.754-3.75 3.655.886 5.166L12 15.75l-4.636 2.44.886-5.166-3.75-3.655 5.182-.754L12 3.75z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Cấp độ</span>
                                    <span>{users.namelevel}</span>
                                </div>
                            )}
                            {users.shop_insurance && (

                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Bảo hiểm</span>

                                    <span>{users.shop_insurance}</span>
                                </div>)}
                            {users.phone && (<div className='flex items-center gap-2 text-base lg:text-lg'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    strokeWidth={1.5}
                                    stroke='currentColor'
                                    className='w-4 h-4'>
                                    <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        d='M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z'
                                    />
                                </svg>

                                <span className='min-w-[110px] lg:min-w-[200px]'>Số điện thoại</span>
                                <span>{users.phone}</span>
                            </div>)}
                            <div className='flex items-center gap-2 text-base lg:text-lg'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    strokeWidth={1.5}
                                    stroke='currentColor'
                                    className='w-4 h-4'>
                                    <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        d='M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z'
                                    />
                                </svg>

                                <span className='min-w-[110px] lg:min-w-[200px]'>Chat</span>
                                <span>
                                    {"https://t.me/" + (users.phone.startsWith("0")
                                        ? "+84" + users.phone.slice(1)
                                        : users.phone)}
                                </span>
                            </div>
                            {users.itemsold && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Đã bán</span>
                                    <span>{users.itemsold}</span>
                                </div>)}
                            <div className='flex items-center gap-2 text-base lg:text-lg'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    strokeWidth={1.5}
                                    stroke='currentColor'
                                    className='w-4 h-4'>
                                    <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        d='M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z'
                                    />
                                </svg>
                                <span className='min-w-[110px] lg:min-w-[200px]'>Ngày mở shop</span>
                                <span>{users.createdate}</span>
                                {console.log(users.createdate)}
                            </div>
                            {users.follower?.toString() && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-4.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Người theo dõi</span>
                                    <span>{users.follower}</span>
                                </div>)}
                            {users.following?.toString() && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z'
                                        />
                                    </svg>
                                    <span className='min-w-[110px] lg:min-w-[200px]'>Đang theo dõi</span>
                                    <span>{users.following}</span>
                                </div>)}
                            {users.verified && (
                                <div className='flex items-center gap-2 text-base lg:text-lg'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                                        />
                                    </svg>

                                    <span className='min-w-[110px] lg:min-w-[200px]'>Tích xanh</span>
                                    <span>{users.verified ? users.verified.toString() : ''}</span>
                                </div>
                            )}

                            <div className='flex items-center gap-2 text-base lg:text-lg'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    strokeWidth={1.5}
                                    stroke='currentColor'
                                    className='w-4 h-4'>
                                    <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        d='M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z'
                                    />
                                </svg>

                                <span className='min-w-[110px] lg:min-w-[200px]'>Online gần nhất</span>
                                <span>Online hai phút trước</span>
                            </div>
                        </div>
                    </>
                )

            }
        </>


    )
}

export default Description
